import React, { useState } from 'react';
import PickUpFields from './pickupFields';
import PickUpInfo from './pickupInfo';
import PickUpInfoLeg from './pickupLegIngo';
import { useShipForm } from '../../../context/shipForms';
import {
  pickupPayloadValidationValues,
  pickupValidationPayloadInitialValues,
} from '../../../initial-values';
import { AddressDto, pickupValidationPayloadDto } from '../../../types';
import { verifyPickupValidate } from '../../../api/shipmentForms';
import { formatDateWithDashes } from '../../../utils/helper';
import { useSnackbar } from 'notistack';
import { useLocation } from 'react-router-dom';
interface Props {
  setShowSummary: any;
  setShowPickup: any;
  setCurrentShipmentStatus: any;
}
function PickupForm({
  setShowPickup,
  setShowSummary,
  setCurrentShipmentStatus,
}: Props) {
  const {
    getPickupValidateDataContext,
    getOriginFormData,
    getSelectedRateContext,
    setPickupPayloadContext,
    getPickupTimezoneDataContext,
    getPickupPayloadContext,
    getSelectedATALegsInfo,
    getSelectedMultiLegRateContext,
    getMultiLegListContext,
    getSelectedServiceContext,
    setSelectedServiceContext,
  } = useShipForm();
  const { enqueueSnackbar } = useSnackbar();
  const location = useLocation();
  const isAddLeg = location.pathname === '/app/add-leg';
  const selectedRateContextData: any = getSelectedRateContext();
  const selectedMultiLegRateContext: any = getSelectedMultiLegRateContext();
  const multiLegListContext: any = getMultiLegListContext();
  const pickupValidateDataContext: any = getPickupValidateDataContext();
  const timezoneDataFromContext: any = getPickupTimezoneDataContext();
  const originFormContextData: AddressDto = getOriginFormData();
  const pickupContextData: any = getPickupPayloadContext();
  const selectedATALegsInfoContext: any = getSelectedATALegsInfo();
  const selectedServiceContext: any = getSelectedServiceContext();

  const [pickupPayloadForm, setPickupPayloadForm] =
    useState<pickupValidationPayloadDto>(pickupValidationPayloadInitialValues);
  const [pickupPayloadValidation, setPickupPayloadValidation] = useState<any>(
    pickupPayloadValidationValues
  );
  const [isValidating, setIsValidating] = useState(false);
  const [loading, setLoading] = useState(false);
  const [bookPickUp, setBookPickUp] = useState(
    pickupContextData ? pickupContextData?.is_pickup : true
  );
  function backRoute() {
    setShowPickup && setShowPickup(false);
    setCurrentShipmentStatus && setCurrentShipmentStatus('rates');
  }
  function nextSummary() {
    if (
      bookPickUp &&
      (pickupPayloadForm?.startTime === '' || pickupPayloadForm?.endTime === '')
    ) {
      enqueueSnackbar('Please fill all fields.', {
        variant: 'error',
      });
      return;
    }

    let payload = {
      carrier_id: isAddLeg
        ? selectedMultiLegRateContext[0]?.routing?.carrier_id
        : selectedRateContextData?.main?.routing[0]?.carrier_id,
      city: isAddLeg
        ? multiLegListContext[0]?.origin?.city
        : originFormContextData?.city,
      province: isAddLeg
        ? multiLegListContext[0]?.origin?.province
        : originFormContextData?.province,
      country: isAddLeg
        ? multiLegListContext[0]?.origin?.country
        : originFormContextData?.country,
      date: bookPickUp
        ? formatDateWithDashes(pickupPayloadForm.date)
        : undefined,
      start_time: bookPickUp ? pickupPayloadForm?.startTime : undefined,
      end_time: bookPickUp ? pickupPayloadForm?.endTime : undefined,
      is_pickup: bookPickUp,
    };
    console.log(payload, 'payload');
    if (bookPickUp) {
      setLoading(true);
      validatePickUp(payload);
    } else {
      setPickupPayloadContext(payload);
      window.scrollTo(0, 0);
      setShowSummary(true);
      setLoading(false);
      setShowPickup('false');
      setCurrentShipmentStatus('summary');
    }
  }
  function validatePickUp(payload: any) {
    verifyPickupValidate(payload)
      .then((response) => {
        if (response?.data?.is_error === false) {
          setPickupPayloadContext(payload);
          if (isAddLeg) {
            const updatedArray = [...selectedServiceContext];
            if (updatedArray.length > 0) {
              updatedArray[0] = {
                ...updatedArray[0],
                is_pickup: bookPickUp,
                pickup: bookPickUp ? payload : undefined,
              };
            }
            setSelectedServiceContext(updatedArray);
          }

          window.scrollTo(0, 0);
          setShowSummary(true);
          setLoading(false);
          setShowPickup('false');
          setCurrentShipmentStatus('summary');
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  }

  return (
    <div id='pickup_section'>
      {loading && (
        <div className='loader-container'>
          <div className='spinner'></div>
        </div>
      )}

      <div className='row g-5'>
        <div className='col-sm-12 col-md-6'>
          <PickUpFields
            pickupPayloadForm={pickupPayloadForm}
            setPickupPayloadForm={setPickupPayloadForm}
            pickupPayloadValidation={pickupPayloadValidation}
            setPickupPayloadValidation={setPickupPayloadValidation}
            isValidating={isValidating}
            pickupValidateDataContext={pickupValidateDataContext}
            timezoneDataFromContext={timezoneDataFromContext}
            bookPickUp={bookPickUp}
            setBookPickUp={setBookPickUp}
          />
        </div>
        <div className='col-sm-12 col-md-6 d-flex flex-column'>
          <div className='ubbe-card h-auto flex-grow-1'>
            <div className='ubbe-card-header'>
              <h5 className='ps-3 mb-0 GlobalBoxHead'>Pickup Restrictions</h5>
            </div>
            <div className='card-body pt-3 p-4'>
              {pickupValidateDataContext &&
                pickupValidateDataContext.length > 0 &&
                pickupValidateDataContext.map((response: any) => (
                  <PickUpInfo
                    data={response}
                    key={response.id}
                  />
                ))}
            </div>
          </div>
        </div>
      </div>

      <div className='row mt-4'>
        <div className='col-sm-12'>
          <table
            className='table'
            id='accounts_table'
          >
            <thead className='position-sticky top-0 ubbe-table-header'>
              <tr>
                <th
                  scope='col'
                  className={`text-start align-middle ubbe-table-heading-text`}
                >
                  Carrier
                </th>
                <th
                  scope='col'
                  className={`text-start align-middle ubbe-table-heading-text`}
                >
                  Route
                </th>
                <th
                  scope='col'
                  className={`text-start align-middle ubbe-table-heading-text`}
                >
                  Transit Time
                </th>
                <th
                  scope='col'
                  className={`text-start align-middle ubbe-table-heading-text`}
                >
                  Est. Delivery Date
                </th>
              </tr>
            </thead>
            <tbody
              id='accounts_rows'
              className='legs'
            >
              {selectedATALegsInfoContext &&
                selectedATALegsInfoContext.length > 0 &&
                selectedATALegsInfoContext.map((item: any, index: number) => (
                  <PickUpInfoLeg
                    legInfo={item}
                    travellingFrom={`${item?.routing?.origin}`}
                    travellingTo={`${item?.routing?.destination}`}
                    leg={`${index + 1}`}
                  />
                ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className='d-flex my-3 justify-content-between align-items-center'>
        <div className=''>
          <p
            className='btn btn-ubbe-new-back d-flex gap-2'
            onClick={() => {
              backRoute();
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='15'
              height='8'
              viewBox='0 0 15 8'
              fill='none'
            >
              <path
                d='M3.03077 0.670207L0.176923 3.5735C0.123077 3.62828 0.0769229 3.69871 0.0461536 3.77697C0.0461536 3.7848 0.0461536 3.79262 0.0384613 3.80045C0.0153844 3.86305 -1.56239e-07 3.92566 -1.53161e-07 3.99609C-1.4632e-07 4.1526 0.0615383 4.30129 0.169231 4.41084L3.03077 7.32979C3.25385 7.55674 3.62308 7.55674 3.84615 7.32979C4.06923 7.10285 4.06923 6.72722 3.84615 6.50028L1.96154 4.58301L14.4231 4.58301C14.7385 4.58301 15 4.31694 15 3.99609C15 3.67524 14.7385 3.40917 14.4231 3.40917L1.96923 3.40917L3.84615 1.49972C3.96154 1.38234 4.01538 1.23365 4.01538 1.08496C4.01538 0.936277 3.96154 0.787591 3.84615 0.670207C3.62308 0.443265 3.26154 0.443265 3.03077 0.670207Z'
                fill='black'
              />
            </svg>
            Back
          </p>
        </div>
        <div className=''>
          <p
            className='btn btn-ubbe-new-blue'
            onClick={() => {
              !loading && nextSummary();
            }}
          >
            Next
          </p>
        </div>
      </div>
    </div>
  );
}

export default PickupForm;
